export default __webpack_public_path__ + "static/ayaanaabhi-work-8049516_1920-4219b70383258c4293e1101c6cd4de33.jpg";